var _defs, _g, _g2, _g3, _path, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillarMindIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "333px",
    height: "220px",
    viewBox: "0 0 333 220",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.4122371%",
    cy: "0%",
    fx: "49.4122371%",
    fy: "0%",
    r: "79.9715909%",
    gradientTransform: "translate(0.494122,0.000000),scale(0.396396,1.000000),rotate(90.000000),scale(1.000000,1.707647),translate(-0.494122,-0.000000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.3942854,0 C48.7732951,0 56.5568116,2.52768901 63.0079874,6.85788588 C63.6034806,16.0793251 61.7388051,24.4293533 63.489194,30.3292838 C66.4877126,40.4400399 79.7660068,49.628652 73.5584418,54.8123542 C71.5945175,56.3701508 68.2200563,56.4716164 66.2320716,58.0055387 C63.083176,60.4436992 65.2365754,63.0788224 65.5162768,64.9857802 C65.6516161,65.8900185 64.8275498,67.343365 62.0967025,69.1070772 C64.1538606,70.6141409 63.9673931,71.8884304 63.233553,73.0642385 C56.7372641,77.4869482 48.8695364,80.0773072 40.3942854,80.0773072 C18.0873526,80.0773072 0,62.1507099 0,40.0371614",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.07992033e-05%",
    y1: "49.9984601%",
    x2: "100.000192%",
    y2: "49.9984601%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00126056055%",
    y1: "50.0004413%",
    x2: "100.00237%",
    y2: "50.0004413%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00267928098%",
    y1: "49.9979314%",
    x2: "100.005203%",
    y2: "49.9979314%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.1157656%",
    y1: "85.3325143%",
    x2: "84.889235%",
    y2: "14.6483028%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "0 0 10.3036898 0 10.3036898 10.3656666 0 10.3656666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,35 C0,54.3288046 16.1220146,70 36,70 L36,70 C55.8810023,70 72,54.3288046 72,35 L72,35 C72,15.6711954 55.8810023,0 36,0 L36,0 C16.1220146,0 0,15.6711954 0,35 L0,35 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,35.0014954 C0,54.2832728 15.8603343,69.9282205 35.4486523,70 L35.4486523,70 C12.3769062,69.8624226 12.4246244,35.0014954 35.5888245,35.0014954 L35.5888245,35.0014954 C58.8037252,35.0014954 58.8037252,0 35.5888245,0 L35.5888245,0 C15.9378763,0 0,15.671865 0,35.0014954 L0,35.0014954 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 C0,10.8633063 3.13262099,14 6.99853342,14 L6.99853342,14 C10.867379,14 14,10.8633063 14,7 L14,7 C14,3.13669372 10.867379,0 6.99853342,0 L6.99853342,0 C3.13262099,0 0,3.13669372 0,7 L0,7 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.99850459 C0,10.865627 3.13262099,14 6.99853342,14 L6.99853342,14 C10.867379,14 14,10.865627 14,6.99850459 L14,6.99850459 C14,3.13138218 10.867379,0 6.99853342,0 L6.99853342,0 C3.13262099,0 0,3.13138218 0,6.99850459 L0,6.99850459 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.083333,1.000000),rotate(90.000000),scale(1.000000,12.250247),translate(-0.489155,-0.509384)",
    id: "radialGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.1464844%",
    fx: "50%",
    fy: "50.1464844%",
    r: "49.8535156%",
    id: "radialGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "33.7098818%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "41.3800322%",
    x2: "24.2768159%",
    y2: "58.2344238%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36,31 L36.0002435,30.8740452 C34.2748927,30.4300871 33,28.8639271 33,27 C33,24.790861 34.790861,23 37,23 C38.3936442,23 39.6208234,23.7127211 40.3369298,24.7935553 C41.0076394,23.1540312 42.6190505,22 44.5,22 L44.3091598,22.0044728 C45.2296422,19.1106857 48.1007263,17 51.5,17 C55.3310152,17 58.4911495,19.6808904 58.9442586,23.1422696 C59.2797953,23.0491126 59.6341622,23 60,23 C62.209139,23 64,24.790861 64,27 C64,27.5583793 63.8855872,28.0900361 63.6789262,28.5728059 C63.8797924,28.8270992 64,29.1495116 64,29.5 C64,30.3284271 63.3284271,31 62.5,31 C62.3247916,31 62.1565993,30.9699604 62.0002925,30.9147505 L62,31 L36,31 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.3%",
    y: "-25.0%",
    width: "122.6%",
    height: "150.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.6400863%",
    id: "radialGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-25",
    cx: 32,
    cy: 30,
    r: 13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "44.0565927%",
    x2: "24.2768159%",
    y2: "55.6775774%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6,48 L6.00061211,47.9775233 C5.83573225,47.9923999 5.66875367,48 5.5,48 C2.46243388,48 0,45.5375661 0,42.5 C0,39.4624339 2.46243388,37 5.5,37 C5.67252662,37 5.84319788,37.0079437 6.01166798,37.0234854 C6.25935565,31.4460389 10.8604638,27 16.5,27 C21.5220883,27 25.7206866,30.5257797 26.7555361,35.2370802 C27.3103692,35.0825057 27.8955495,35 28.5,35 C30.8343839,35 32.8813523,36.2305719 34.0275959,38.0784063 C34.8578406,37.4004535 35.8864062,37 37,37 C38.9991407,37 40.7242529,38.2905807 41.5243389,40.1556446 C42.4034774,38.2904749 44.3010354,37 46.5,37 C49.4282963,37 51.8220943,39.288459 51.9905284,42.1745111 C52.3050343,42.0615466 52.6453296,42 53,42 C54.6568542,42 56,43.3431458 56,45 C56,46.6568542 54.6568542,48 53,48 L53,48 L6,48 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.1%",
    y: "-19.0%",
    width: "114.3%",
    height: "138.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-28"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "26.468099%",
    fx: "50%",
    fy: "26.468099%",
    r: "54.4385119%",
    gradientTransform: "translate(0.500000,0.264681),scale(1.000000,0.984375),rotate(-178.908467),scale(1.000000,0.513276),translate(-0.500000,-0.264681)",
    id: "radialGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF520B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53F00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "26.468099%",
    fx: "50%",
    fy: "26.468099%",
    r: "177.565198%",
    gradientTransform: "translate(0.500000,0.264681),scale(0.306533,1.000000),rotate(-179.670601),scale(1.000000,0.513276),translate(-0.500000,-0.264681)",
    id: "radialGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF520B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C53F00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-33",
    cx: 10.8318584,
    cy: 21.6637168,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-470.8%",
    y: "-470.8%",
    width: "1041.7%",
    height: "1041.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-34"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.831372549   0 0 0 0 0.262745098   0 0 0 0 0.0117647059  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-35",
    cx: 31.2212389,
    cy: 21.6637168,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-470.8%",
    y: "-470.8%",
    width: "1041.7%",
    height: "1041.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-36"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.831372549   0 0 0 0 0.262745098   0 0 0 0 0.0117647059  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.7096706%",
    y1: "-3.96540032%",
    x2: "49.7096706%",
    y2: "60.871198%",
    id: "linearGradient-37"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.3776516,12.587128 C28.2138314,13.3471676 26.8621513,18.5934319 26.8879439,19.3877682 C27.8499319,20.2702291 28.9492933,18.3792415 29.5321493,18.2763515 C30.46199,18.1124379 30.7705663,18.2474751 30.7553338,17.4445412 C30.7424375,16.7630007 29.4900962,13.7962947 28.3776516,12.587128 Z M10.0449302,12.587128 C8.93248553,13.7962947 7.68014425,16.7630007 7.66724796,17.4445412 C7.65210885,18.2474751 7.96059169,18.1124379 8.89043243,18.2763515 C9.47328838,18.3792415 10.5726498,20.2702291 11.5347313,19.3877682 C11.5467242,19.0170779 11.2587749,17.6768567 10.9315592,16.2754856 L10.7896798,15.6738024 C10.456565,14.2734983 10.1214232,12.9418131 10.0449302,12.587128 Z M25.9949815,1.24745531 L25.894089,1.13158348 C28.2714908,1.96862705 30.1398633,3.23526638 31.7414322,4.82991989 L31.7414322,4.82991989 L37.701945,15.4328144 L38.2476073,16.4038672 L37.9353864,17.1430672 L36.5644554,20.3810624 L21.1012759,33.3670602 L19.2586025,33.0724082 L17.4159292,33.3670602 L1.85812634,20.3810624 L0.487195312,17.1430672 L0.174974416,16.4038672 L0.720636736,15.4328144 L6.68124297,4.82991989 C8.28271843,3.23526638 10.1510909,1.96862705 12.5284927,1.13158348 L12.5284927,1.13158348 L12.9212462,0.998566895 C13.3184859,0.86928428 13.7293797,0.751395426 14.1559383,0.646122502 C15.6431228,0.27736355 17.3130981,0.0558838958 19.2110012,-7.97537061e-13 L19.2110012,-7.97537061e-13 L19.7742082,0.021714725 C21.4416321,0.10165262 22.9281587,0.314239445 24.2666247,0.646122502 C24.8353695,0.7864864 25.3762658,0.949278619 25.8940796,1.13160217 C25.9608693,1.20597073 26.0286589,1.28602675 26.0971128,1.37219738 L25.9949815,1.24745531 L25.9949815,1.24745531 Z",
    id: "path-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "50%",
    id: "radialGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.066667,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.088889,1.000000),rotate(90.000000),scale(1.000000,12.250247),translate(-0.489155,-0.509384)",
    id: "radialGradient-42"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-43",
    x: 52.460199,
    y: 30.7964602,
    width: 31.2212389,
    height: 20.6017699,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-12.1%",
    width: "116.0%",
    height: "124.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-44"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.224431818 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M70.414425,41.1541042 C70.414425,39.8911094 69.3905722,38.8672566 68.1274841,38.8672566 C66.8645828,38.8672566 65.84073,39.8911094 65.84073,41.1541042 C65.84073,42.4170989 66.8645828,43.4409517 68.1274841,43.4409517 C69.3905722,43.4409517 70.414425,42.4170989 70.414425,41.1541042",
    id: "path-45"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.9%",
    y: "-21.9%",
    width: "143.7%",
    height: "143.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-46"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.224431818 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "84.8007374%",
    x2: "50%",
    y2: "11.8240871%",
    id: "linearGradient-47"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B1A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333431",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-48"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333431",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1D1C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.467166385%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-49"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343532",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-50"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-51"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.150000,1.000000),rotate(90.000000),scale(1.000000,6.430410),translate(-0.489155,-0.509384)",
    id: "radialGradient-52"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "22.8553185%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-53"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7393534,67.7814939 L37.4153846,67.7814939 L37.4153846,71.8911929 C37.4153846,72.9157211 36.5848404,73.7462653 35.5603122,73.7462653 L30.5944259,73.7462653 C29.5698976,73.7462653 28.7393534,72.9157211 28.7393534,71.8911929 L28.7393534,67.7814939 L28.7393534,67.7814939 Z",
    id: "path-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.5280762%",
    x2: "50%",
    y2: "80.4794312%",
    id: "linearGradient-55"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.4013378,52.0561873 L41.7534002,52.0561873 L41.7534002,64.7705686 C41.7534002,67.3318891 39.6770396,69.4082497 37.1157191,69.4082497 L29.039019,69.4082497 C26.4776984,69.4082497 24.4013378,67.3318891 24.4013378,64.7705686 L24.4013378,52.0561873 L24.4013378,52.0561873 Z",
    id: "path-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-57"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-58",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 30.3661093
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "-2.5%",
    width: "104.9%",
    height: "104.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-59"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-60",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 26.5703456
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.8%",
    y: "-2.8%",
    width: "105.6%",
    height: "105.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-61"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-62"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-63",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 26.5703456
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.3%",
    y: "-3.3%",
    width: "106.6%",
    height: "106.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-64"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-65",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 28.7393534
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.1%",
    y: "-3.1%",
    width: "106.1%",
    height: "106.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-66"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "13.5723305%",
    x2: "0%",
    y2: "86.4276695%",
    id: "linearGradient-67"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.05520881,-0.886553687 L6.52214845,25.6864924 C6.47330119,26.5331783 7.12007716,27.2591513 7.96676302,27.3079986 C7.99621434,27.3096977 8.02570851,27.3105478 8.05520881,27.3105478 C8.90330254,27.3105478 9.59081836,26.6230319 9.59081836,25.7749382 C9.59081836,25.7454379 9.58996827,25.7159437 9.58826916,25.6864924 L8.05520881,-0.886553687 L8.05520881,-0.886553687 Z",
    id: "path-68"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-61.5%",
    y: "-7.1%",
    width: "189.4%",
    height: "110.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-69"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "events-icon_mind",
    transform: "translate(0.000000, -31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 31.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic-healthy-bites-hero",
    fill: "url(#radialGradient-1)",
    opacity: 0.54577782
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.5,132 C258.455411,132 333,72.901587 333,0 C312.416209,0 24.2431319,0 0,0 C0,72.901587 74.5445892,132 166.5,132 Z",
    id: "sky",
    transform: "translate(166.500000, 66.000000) scale(1, -1) translate(-166.500000, -66.000000) "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(93.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(45.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4405197,18.7801026 C34.6555961,18.7801026 38.9112669,14.5603243 38.9112669,9.39154346 C38.9112669,4.21977835 34.6555961,0 29.4405197,0 C24.2224358,0 19.966765,4.21977835 19.966765,9.39154346 C19.966765,14.5603243 24.2224358,18.7801026 29.4405197,18.7801026",
    id: "Fill-1",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3349964,26.0238565 C80.4027033,31.9088656 83.8794209,38.9129815 85.2508596,46.8362569 C87.175686,57.964654 84.2433333,68.2753571 86.3004915,75.2048658 C86.7456076,76.7119295 87.4253119,78.2010875 88.2283254,79.6574183 C83.9335566,82.1403431 78.9410383,83.5638468 73.6146829,83.5638468 C57.5694507,83.5638468 44.5618352,70.6717376 44.5618352,54.7684852 C44.5618352,38.8652329 57.5694507,25.9701394 73.6146829,25.9701394 C74.1921308,25.9701394 74.7665711,25.9910294 75.3349964,26.0238565",
    id: "Fill-3",
    fill: "#2CB5D6",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(22.808591, 44.874687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0079874,6.85788588 C63.6034806,16.0793251 61.7388051,24.4293533 63.489194,30.3292838 C66.4877126,40.4400399 79.7660068,49.628652 73.5584418,54.8123542 C71.5945175,56.3701508 68.2200563,56.4716164 66.2320716,58.0055387 C63.083176,60.4436992 65.2365754,63.0788224 65.5162768,64.9857802 C65.6516161,65.8900185 64.8275498,67.343365 62.0967025,69.1070772 C64.1538606,70.6141409 63.9673931,71.8884304 63.233553,73.0642385 C56.7372641,77.4869482 48.8695364,80.0773072 40.3942854,80.0773072 C18.0873526,80.0773072 0,62.1507099 0,40.0371614 C0,17.923613 18.0873526,0 40.3942854,0 C48.7732951,0 56.5568116,2.52768901 63.0079874,6.85788588",
    id: "Fill-5",
    fill: "url(#linearGradient-4)",
    opacity: 0.78,
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.1704988,140.216311 C61.804971,146.408701 41.2785025,125.650018 38.5145722,168 C28.6227693,161.655411 18.1475034,156.176265 6.79704304,151.998266 C2.50828933,145.761112 0,138.228777 0,130.114508 C0,108.624675 17.5760706,91.2054058 39.2574348,91.2054058 C60.9357916,91.2054058 78.5088546,108.624675 78.5088546,130.114508 C78.5088546,133.609105 78.0426857,136.993284 77.1704988,140.216311",
    id: "Fill-8",
    fill: "#2CB5D6",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6373989,140.430583 C46.5290679,140.770791 39.9936809,145.396432 38.5169782,167.999403 C28.6793111,161.690626 18.264196,156.235353 6.98290908,152.066308 C7.30471598,138.422159 18.5619426,127.457898 32.402647,127.457898 C41.9666279,127.457898 50.297517,132.695317 54.6373989,140.430583",
    id: "Fill-10",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(46.865912, 100.564421)",
    fill: "url(#linearGradient-5)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.854469,1.03853102 C43.8649879,1.36680232 42.9236275,1.73983789 42.1747498,2.31580481 C39.0258542,4.75396528 41.1792536,7.38908853 41.458955,9.29604636 C41.5942943,10.2002846 40.770228,11.6536311 38.0393807,13.4173433 C41.1912838,15.7241953 39.0679597,17.4908917 37.8017849,19.1889496 C31.8979816,23.4176808 40.1115765,32.5406387 30.3731582,39.6253302 C20.5505288,43.6391929 8.59856019,36.5634542 0.532334786,41.9948521 C0.183460011,40.00135 0,37.9511466 0,35.8591631 C0,16.0554508 16.1986167,0 36.1777127,0 C39.1672086,0 42.0755009,0.36109843 44.854469,1.03853102",
    id: "Fill-12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5252963,72.9962496 C26.837998,72.9962496 31.1737529,68.6363572 31.1737529,63.2927399 C31.1737529,57.9491226 26.837998,53.5892301 21.5252963,53.5892301 C16.2125946,53.5892301 11.8768398,57.9491226 11.8768398,63.2927399 C11.8768398,68.6363572 16.2125946,72.9962496 21.5252963,72.9962496",
    id: "Fill-21",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35865065,47.5778092 C12.9600406,47.5778092 16.7143498,43.8004246 16.7143498,39.1730541 C16.7143498,34.5427116 12.9600406,30.7653269 8.35865065,30.7653269 C3.75430919,30.7653269 0,34.5427116 0,39.1730541 C0,43.8004246 3.75430919,47.5778092 8.35865065,47.5778092",
    id: "Fill-23",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(18.213712, 8.080810)",
    fill: "url(#linearGradient-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79786547,15.6890744 C12.0982023,15.6890744 15.5986824,12.164308 15.5986824,7.84305123 C15.5986824,3.52179451 12.0982023,0 7.79786547,0 C3.50343161,0 0,3.52179451 0,7.84305123 C0,12.164308 3.50343161,15.6890744 7.79786547,15.6890744",
    id: "Fill-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(23.508705, 32.962213)",
    fill: "url(#linearGradient-7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15332064,10.366261 C7.98971304,10.366261 10.3036898,8.03622983 10.3036898,5.18015851 C10.3036898,2.32705916 7.98971304,0 5.15332064,0 C2.31397673,0 0,2.32705916 0,5.18015851 C0,8.03622983 2.31397673,10.366261 5.15332064,10.366261",
    id: "Fill-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(34.256891, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15036913,10.3656666 C7.98971304,10.3656666 10.3036898,8.03563544 10.3036898,5.18253609 C10.3036898,2.32646476 7.98971304,-0.000594395698 5.15036913,-0.000594395698 C2.31397673,-0.000594395698 0,2.32646476 0,5.18253609 C0,8.03563544 2.31397673,10.3656666 5.15036913,10.3656666",
    id: "Fill-31",
    fill: "#62EBB9",
    mask: "url(#mask-9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3546091,126 C59.2729273,126 64.9132455,120.323521 64.9132455,113.366119 C64.9132455,106.408718 59.2729273,100.732239 52.3546091,100.732239 C45.4333394,100.732239 39.7930211,106.408718 39.7930211,113.366119 C39.7930211,120.323521 45.4333394,126 52.3546091,126",
    id: "Fill-19",
    fill: "#62EBB9",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7332276,21.9213133 C9.88487179,21.9213133 11.6321603,20.1589301 11.6321603,17.9983017 C11.6321603,15.8376734 9.88487179,14.0752901 7.7332276,14.0752901 C5.58453492,14.0752901 3.83429487,15.8376734 3.83429487,17.9983017 C3.83429487,20.1589301 5.58453492,21.9213133 7.7332276,21.9213133",
    id: "Fill-34",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4846758,47.5778092 C66.2340422,47.5778092 75,38.7599491 75,27.9478913 C75,17.1328616 66.2340422,8.31500142 55.4846758,8.31500142 C44.7323579,8.31500142 35.9664001,17.1328616 35.9664001,27.9478913 C35.9664001,38.7599491 44.7323579,47.5778092 55.4846758,47.5778092",
    id: "Fill-36",
    fill: "#2CB5D6",
    opacity: 0.78
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(30.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#F8F8F8",
    mask: "url(#mask-11)",
    points: "-1.30629347 71.2949671 73.3062935 71.2949671 73.3062935 -1.29795779 -1.30629347 -1.29795779"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(30.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#575756",
    mask: "url(#mask-13)",
    points: "-1.29137359 71.2980132 60.0950988 71.2980132 60.0950988 -1.29801325 -1.29137359 -1.29801325"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(59.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#FFFFFF",
    mask: "url(#mask-15)",
    points: "-1.27299392 15.2947458 15.2729939 15.2947458 15.2729939 -1.29474584 -1.27299392 -1.29474584"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(59.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#575756",
    mask: "url(#mask-17)",
    points: "-1.27299392 15.2950224 15.2729939 15.2950224 15.2729939 -1.29801325 -1.27299392 -1.29801325"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.07848,12 C102.90669,15.2701101 116.174146,23.2040987 124,34.627004 C122.411495,46.1338352 112.548406,55 100.609191,55 C87.5720833,55 77,44.4193503 77,31.365886 C77,23.3539663 80.9847241,16.2742228 87.07848,12",
    id: "Fill-51",
    fill: "#62EBB9",
    opacity: 0.78
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 210.000000)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "double-shadow-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    fill: "url(#radialGradient-18)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 80,
    cy: 5,
    rx: 80,
    ry: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    transform: "translate(35.000000, 0.000000)",
    fill: "url(#radialGradient-19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 45,
    cy: 3.75,
    rx: 45,
    ry: 3.75
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.000000, 80.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6666667,26.67 L36.7833335,28.7183333 L56.7616667,19.555 C58.3558334,18.635 58.9025,16.5966667 57.9825,15.0025 C57.0616667,13.4075 55.0233334,12.8608333 53.4291667,13.7816667 L35.5016668,26.4983333 L48.2208334,8.57333333 C49.1416667,6.97916667 48.5950001,4.94 47.0016668,4.01916667 C45.4066668,3.09916667 43.3683334,3.645 42.4475001,5.23916667 L33.2816668,25.2166667 L35.3333335,3.33333333 C35.3333335,1.4925 33.8408335,0 32,0 C30.1591669,0 28.6666669,1.4925 28.6666669,3.33333333 L30.7175002,25.2091667 L21.5658336,5.23416667 C20.6458336,3.63916667 18.6083336,3.09166667 17.0133336,4.01166667 C15.4183336,4.93166667 14.8708336,6.96916667 15.7908336,8.56416667 L28.5,26.4966667 L10.5800003,13.77 C8.98583364,12.8491667 6.94750032,13.3941667 6.02583366,14.9883333 C5.10500033,16.5825 5.65000033,18.6208333 7.24416699,19.5416667 L27.2175002,28.7158333 L5.33500033,26.6558333 C3.49416701,26.655 2.00083368,28.1466667 2,29.9875 C1.99916702,31.8283333 3.49083367,33.3216667 5.331667,33.3225 L27.2166669,31.2791667 L7.23583365,40.4375 C5.64083366,41.3575 5.094167,43.3958333 6.01333366,44.99 C6.93416699,46.585 8.97250031,47.1316667 10.566667,46.2125 L28.4975002,33.5 L15.7725003,51.4216667 C14.8525003,53.0158333 15.3975003,55.055 16.9916669,55.9758333 C18.5858336,56.8966667 20.6250002,56.3508333 21.5458336,54.7575 L30.7166668,34.7825 L28.6591669,56.6658333 C28.6591669,58.5066667 30.1508335,59.9991667 31.9916668,60 C33.8325002,60 35.3258335,58.5083333 35.3258335,56.6675 L33.2808335,34.7833333 L42.4408334,54.7625 C43.3616668,56.3575 45.4000001,56.9041667 46.9941668,55.9833333 C48.5883334,55.0633333 49.1350001,53.025 48.2150001,51.4308333 L35.5008335,33.5016667 L53.4241667,46.2233333 C55.0183334,47.1441667 57.0566667,46.5983333 57.9783334,45.0041667 C58.8983334,43.41 58.3525,41.3716667 56.7591667,40.4508333 L36.7825001,31.2825 L58.6666667,33.3366667 C60.5075,33.3366667 62,31.8441667 62,30.0033333 C62,28.1625 60.5083333,26.67 58.6666667,26.67",
    id: "Fill-1",
    fill: "url(#radialGradient-20)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(48.500000, 24.000000) scale(-1, 1) translate(-48.500000, -24.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-21)",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeOpacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1,
    fill: "url(#radialGradient-24)",
    fillRule: "evenodd",
    cx: 32,
    cy: 30,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 3,
    cx: 32,
    cy: 30,
    r: 14.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-26)",
    fillRule: "evenodd",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-28)",
    xlinkHref: "#path-27"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 60.000000)",
    id: "shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#radialGradient-29)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 2,
    rx: 32,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#radialGradient-30)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 1.5,
    rx: 16,
    ry: 1.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(22.433097, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(45.876106, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#575756",
    points: "1.75196537 76.6725664 12.7433628 53.208876 11.1430318 52.8849558 0 76.6725664"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(27.292035, 64.778761) scale(-1, 1) translate(-27.292035, -64.778761) translate(12.318584, 52.884956)",
    fill: "#575756"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9-Copy",
    points: "1.75196537 23.7876106 12.7433628 0.323920237 11.1430318 0 0 23.7876106"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43-Copy",
    points: "3.57958689 17.6283186 3.18584071 17.1521786 29.5531565 3.39823009 29.9469027 3.87456403"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#575756",
    points: "3.57958689 70.5132743 3.18584071 70.0371343 29.5531565 56.2831858 29.9469027 56.7595198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33628319,53.840708 C2.24068469,56.9972161 3.31894482,58.6133128 5.57106358,58.688998 C7.75493632,58.688998 17.8553477,58.8782111 35.8722978,59.2566372 C38.8524362,58.8101306 40.2401363,57.1110155 40.0353982,54.159292 C37.9880175,51.4346242 25.8856918,51.0902383 3.72842096,53.1261345 L2.33628319,53.840708 Z",
    id: "Path-3",
    fill: "#FF5100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4737074,18.5489379 C20.7427665,18.5582005 20.9978434,18.5628319 21.2389381,18.5628319 C21.5203865,18.5628319 21.8213278,18.5565205 22.1417618,18.5438976 C29.7939016,18.2425108 36.24155,24.201429 36.5429896,31.8535667 C36.5965989,33.2144558 36.4494204,34.5758185 36.1061947,35.8938053 L33.1783036,47.1369072 C31.7755036,52.5236591 26.9115448,56.2831858 21.3451327,56.2831858 C15.7787206,56.2831858 10.9147619,52.5236591 9.51196192,47.1369072 L6.5840708,35.8938053 C4.65499057,28.4861372 9.09626353,20.9172073 16.5039316,18.988127 C17.7990485,18.650857 19.1361862,18.5029416 20.4737074,18.5489379 Z",
    id: "Rectangle",
    fill: "url(#radialGradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21475205,44.0717679 C13.9508585,43.8587309 18.1506609,43.7522124 20.8141593,43.7522124 C23.5185523,43.7522124 27.9141266,43.9032074 34.0008822,44.2051973 C36.1232774,44.3105184 37.758456,46.1164239 37.6531549,48.23882 C37.6080069,49.1487992 37.2414115,50.0132329 36.6186262,50.6782434 L33.638941,53.8599531 C31.9373426,55.676921 29.5591831,56.7079646 27.0698439,56.7079646 L14.9272518,56.7079646 C12.3468178,56.7079646 9.89051188,55.6003591 8.18213044,53.6664324 L5.43447113,50.5560194 C4.00737301,48.9405118 4.16010908,46.4739925 5.7756167,45.0468943 C6.45156615,44.4497779 7.31345375,44.1051912 8.21475205,44.0717679 Z",
    id: "Rectangle-Copy",
    fill: "url(#radialGradient-32)",
    transform: "translate(21.132743, 50.230088) rotate(-180.000000) translate(-21.132743, -50.230088) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-34)",
    xlinkHref: "#path-33"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF520B",
    fillRule: "evenodd",
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-36)",
    xlinkHref: "#path-35"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF520B",
    fillRule: "evenodd",
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.3451327,18.5834927 C21.3451327,18.5834927 21.3451327,18.5834927 21.3451327,18.5834927 C21.3451327,18.5834927 21.3451327,18.5834927 21.3451327,18.5834927 C26.005534,18.5834927 29.8169379,14.8694833 29.9375482,10.210643 C29.9437924,9.9703612 29.9469027,9.73675712 29.9469027,9.50983134 C29.9469027,3.62172472 26.0957591,0 21.3451327,0 C16.5945064,0 12.7433628,3.62172472 12.7433628,9.50983134 C12.7433628,9.70263775 12.7445157,9.89523549 12.7468215,10.0876245 L12.7468311,10.0876244 C12.8032628,14.7961431 16.6362759,18.5834927 21.3451327,18.5834927 Z",
    id: "Oval-Copy-18",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.274336, 5.734513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-+-Oval-Copy-2-Mask",
    transform: "translate(1.486726, 13.912356)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-38"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-37)",
    xlinkHref: "#path-38"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#radialGradient-40)",
    opacity: 0.110212054,
    mask: "url(#mask-39)",
    cx: 34.1946903,
    cy: 19.857555,
    r: 5.52212389
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "url(#radialGradient-40)",
    opacity: 0.110212054,
    mask: "url(#mask-39)",
    cx: 4.24778761,
    cy: 19.857555,
    r: 5.52212389
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.74552189,47.0705521 C8.39416758,47.4657578 9.09580017,47.9968417 9.82668303,48.3686845 C10.0969443,48.5061514 10.3708501,48.6218442 10.6480268,48.699876 C10.6412048,48.5593252 10.5162604,48.2530852 10.3176763,47.840591 C10.0011567,47.1876466 9.494557,46.2706087 8.96235167,45.3333853 C8.00055058,43.6305151 6.95651231,41.8590517 6.82306381,41.4622574 C6.55775548,40.6827798 7.05818736,38.056704 6.96398841,37.244425 C6.78428151,35.6993941 5.21429915,36.3617772 3.95980848,35.0839237 C3.45320882,34.5653622 2.89184667,34.04353 2.30824311,33.4950642 C2.20563355,34.8588929 1.53297087,36.1945927 1.38587848,37.5568328 C1.15309121,39.7314453 5.94163086,45.9753959 7.74552189,47.0705521",
    id: "Fill-19",
    fill: "#F7B58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.547629384,30.7746118 L0.150461228,34.6697567 C0.117846713,34.9890799 0.337831146,35.284573 0.675096999,35.3745667 L6.95895139,37.0014609 C7.49237158,37.1436938 7.99859744,36.7141915 7.88215709,36.2182453 L7.06361688,32.7342862 C7.01399422,32.5230862 6.85578112,32.3466501 6.63878713,32.260488 L1.5706411,30.2225948 C1.11263613,30.040832 0.593887793,30.3208121 0.547629384,30.7746118",
    id: "Fill-23",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6504831,47.0705521 C33.0019309,47.4657578 32.3002983,47.9968417 31.569322,48.3686845 C31.2991542,48.5061514 31.0252483,48.6218442 30.7479782,48.699876 C30.7548936,48.5593252 30.8797446,48.2530852 31.0783287,47.840591 C31.3948484,47.1876466 31.901448,46.2706087 32.4336533,45.3333853 C33.3954544,43.6305151 34.4394927,41.8590517 34.5729412,41.4622574 C34.838343,40.6827798 34.3378177,38.056704 34.4321101,37.244425 C34.6117235,35.6993941 36.1817993,36.3617772 37.43629,35.0839237 C37.9428897,34.5653622 38.5041583,34.04353 39.0877619,33.4950642 C39.1903715,34.8588929 39.8631276,36.1945927 40.0101265,37.5568328 C40.2430073,39.7314453 35.4543742,45.9753959 33.6504831,47.0705521",
    id: "Fill-11",
    fill: "#F7B58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8484224,30.7746118 L41.245684,34.6697567 C41.278205,34.9890799 41.0581271,35.284573 40.7209547,35.3745667 L34.4371004,37.0014609 C33.9036802,37.1436938 33.3974543,36.7141915 33.5139881,36.2182453 L34.3324349,32.7342862 C34.382151,32.5230862 34.5402706,32.3466501 34.7572646,32.260488 L39.8255041,30.2225948 C40.2834156,30.040832 40.802164,30.3208121 40.8484224,30.7746118",
    id: "Fill-15",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7137217,29.1777016 C20.7102217,29.1748016 20.7065217,29.1716016 20.7008217,29.1671016 C20.7008217,29.1671016 20.7074217,29.1724016 20.7137217,29.1777016",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7131487,29.1772301 C20.7148487,29.1786301 20.7164487,29.1799301 20.7177487,29.1810301 C20.7162487,29.1797301 20.7148487,29.1786301 20.7131487,29.1772301",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.717354,29.1807226 C20.724754,29.1868226 20.728854,29.1901226 20.717354,29.1807226",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6852464,29.1807226 C20.6737464,29.1901226 20.6778464,29.1868226 20.6852464,29.1807226",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7016726,29.1670549 C20.6960726,29.1716549 20.6923726,29.1747549 20.6888726,29.1776549 C20.6952726,29.1724549 20.7016726,29.1670549 20.7016726,29.1670549",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6894517,29.1772301 C20.6877517,29.1786301 20.6863517,29.1797301 20.6848517,29.1810301 C20.6861517,29.1799301 20.6877517,29.1786301 20.6894517,29.1772301",
    id: "Fill-37",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8834453,10.0531177 C23.8320471,9.6563233 23.7739204,9.26102417 23.7088782,8.86908929 C23.6609377,8.5785491 23.6095395,8.28782201 23.5480485,7.99896395 C23.2989072,6.85540001 23.2266694,6.99557701 20.6979698,7.09921453 C18.1693637,6.99557701 18.0971258,6.85540001 17.8479846,7.99896395 C17.7864936,8.28782201 17.7350954,8.5785491 17.6871548,8.86908929 C17.6221127,9.26102417 17.563986,9.6563233 17.5125877,10.0531177 C17.3722238,11.1388352 17.2953134,12.2369818 17.3278345,13.3290541 C17.3568044,14.3288898 17.5194097,15.448904 18.305055,16.2081027 C19.0733184,16.9521622 19.8861581,17.2881197 20.6976894,17.3425084 L20.6976894,17.3425084 C20.6977829,17.3425084 20.6978764,17.3425084 20.6979698,17.3425084 C20.6981567,17.3425084 20.6982502,17.3425084 20.6983436,17.3425084 L20.6983436,17.3425084 C21.509875,17.2881197 22.3227146,16.9521622 23.0910715,16.2081027 C23.8766234,15.448904 24.0392287,14.3288898 24.068292,13.3290541 C24.1007197,12.2369818 24.0238092,11.1388352 23.8834453,10.0531177",
    id: "Fill-41",
    fill: "#F39F85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8636451,7.04567428 C26.7964536,8.53617852 26.5496487,10.0469337 25.7483035,11.2413008 C25.4763601,11.6472839 25.1561959,12.0591407 24.796969,12.4474152 C23.3923954,13.9686027 21.3897334,15.1395629 19.3635217,14.2221339 C18.1497758,13.6726409 16.9999506,12.8270108 16.1720653,11.7850955 C15.486226,10.9233348 15.0223336,9.92683072 14.9239293,8.85703756 C14.8426266,7.9704672 14.8583265,7.08521183 14.9115003,6.20442745 C14.9723371,5.17425951 15.0863477,4.15136788 15.1628844,3.14171389 C16.5501694,2.27276447 17.7545701,1.61605542 18.8105701,1.13836118 C22.1755657,-0.384316631 24.0359948,-0.0750295507 25.5310292,1.08567367 C26.2763035,1.66444728 26.6215127,2.51884407 26.7729973,3.39822579 C26.8479453,3.83489216 26.8745789,4.27883484 26.8792515,4.6964776 C26.8871014,5.43813539 26.9027078,6.23817901 26.8636451,7.04567428",
    id: "Fill-44",
    fill: "#F7B58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4778981,10.4298592 L23.2556909,10.4298592 C23.2556909,10.4298592 22.8552519,13.1496667 20.822592,12.9921078 C18.7899321,12.8344554 18.4778981,10.4298592 18.4778981,10.4298592",
    id: "Fill-46",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.0392662,4.16489497 C23.9651687,6.2116969 25.9638794,7.51723162 28.0353982,8.08149914 C28.0353982,7.44488963 27.7498681,5.89456715 27.1788079,3.43053168 L17.5115748,3.43053168 C15.7168142,6.85756033 15.268124,9.26463998 16.1655043,10.6517706 C18.53134,10.0875031 20.4892606,7.92521122 22.0392662,4.16489497 Z",
    id: "Path-28-Copy-2",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9911504,5.76681487 C17.3503774,5.76644189 17.7087632,5.89344225 18.0171526,6.09959588 C18.3266634,6.30677748 18.5787017,6.60984015 18.7342047,6.95364759 C18.8113955,7.12597185 18.8636348,7.30708053 18.8983052,7.48959098 C18.9112949,7.58145363 18.9280227,7.67275559 18.9305459,7.76480515 C18.9389565,7.8564809 18.9374613,7.94815666 18.9348447,8.03917825 C18.9218549,8.40363844 18.8408326,8.75781899 18.6966372,9.08433794 C18.6881332,8.72772766 18.6846755,8.38382676 18.6410337,8.05104657 C18.6213155,7.88479665 18.5907569,7.72247169 18.5516942,7.56397824 C18.508987,7.40698 18.4598316,7.25297221 18.3935746,7.10728158 C18.2610606,6.81618069 18.0751859,6.55264793 17.8355767,6.3293927 C17.5965282,6.10557677 17.3129034,5.91717888 16.9911504,5.76681487",
    id: "Fill-49",
    fill: "#FFFFFF",
    opacity: 0.12593006,
    transform: "translate(17.964025, 7.425576) rotate(71.000000) translate(-17.964025, -7.425576) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6283186,5.73451327 C17.7471887,5.73544779 17.8631618,5.78011752 17.963622,5.85001912 C18.0630542,5.92113558 18.1472538,6.0242124 18.1906152,6.14439081 C18.2335094,6.26372816 18.2444432,6.39362551 18.2192113,6.5123087 C18.2108007,6.57230446 18.1841671,6.62772109 18.1654768,6.68276393 C18.1374414,6.73537703 18.1078174,6.78621455 18.0722124,6.83256641 C18.0688482,6.77200995 18.073988,6.71649986 18.0761374,6.66164393 C18.0733338,6.60650764 18.0780064,6.55314693 18.0726797,6.5013749 C18.0689416,6.39727011 18.047074,6.30120214 18.0158613,6.21064781 C17.9506322,6.02860461 17.8096142,5.88048425 17.6283186,5.73451327",
    id: "Fill-50",
    fill: "#454545",
    transform: "translate(17.930458, 6.283540) rotate(62.000000) translate(-17.930458, -6.283540) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2201336,3.44287051 C22.4534152,5.95108796 22.1812534,7.650203 21.4036482,8.54021564 C21.0537258,6.59836988 20.9370851,6.2342738 20.4705219,5.50608163 C20.1594799,5.02062019 20.7426838,4.33288315 22.2201336,3.44287051 Z",
    id: "Path",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.460177, 87.504425)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "double-shadow-01-copy-14",
    transform: "translate(63.716814, 4.247788) scale(-1, 1) translate(-63.716814, -4.247788) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    fill: "url(#radialGradient-41)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 63.7168142,
    cy: 4.24778761,
    rx: 63.7168142,
    ry: 4.24778761
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    transform: "translate(27.876106, 0.000000)",
    fill: "url(#radialGradient-42)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 35.840708,
    cy: 3.18584071,
    rx: 35.840708,
    ry: 3.18584071
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 73.061947)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "double-shadow-01-copy-16",
    transform: "translate(63.716814, 4.247788) scale(-1, 1) translate(-63.716814, -4.247788) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    fill: "url(#radialGradient-41)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 63.7168142,
    cy: 4.24778761,
    rx: 63.7168142,
    ry: 4.24778761
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    transform: "translate(27.876106, 0.000000)",
    fill: "url(#radialGradient-42)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 35.840708,
    cy: 3.18584071,
    rx: 35.840708,
    ry: 3.18584071
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#C4C4C4",
    fillRule: "evenodd",
    xlinkHref: "#path-43"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-44)",
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-59",
    opacity: 0.597237723
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#C4C4C4",
    fillRule: "evenodd",
    xlinkHref: "#path-45"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-46)",
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.7964602,50.3362832 L61.5431715,51.2920354 L74.8509926,51.2920354 L81.5575221,50.3362832 L83.6814159,58.5132743 L77.9602966,59.7876106 L77.679955,59.7389223 C71.3931321,58.6470587 64.9637555,58.6635365 58.6826118,59.7876106 L58.6826118,59.7876106 L58.6826118,59.7876106 L54.7964602,50.3362832 Z",
    id: "Path-59",
    fill: "url(#linearGradient-47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F7B58E",
    x: 56.7079646,
    y: 83.2566372,
    width: 4.03539823,
    height: 2.33628319
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#F7B58E",
    x: 74.9734513,
    y: 83.2566372,
    width: 4.03539823,
    height: 2.33628319
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#F7B58E",
    x: 74.9734513,
    y: 83.2566372,
    width: 4.03539823,
    height: 1.91150442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6460177,80.0707965 C50.9290212,65.0847356 49.7581772,55.6716953 52.1334857,51.8316755 C52.2607344,51.8316755 53.4059725,49.1732003 56.8416867,50.9455171 C60.2774009,52.7178339 61.1681416,58.3301706 61.1681416,79.5979726 L61.1681416,83.3818016 L56.3893805,83.3628319 L55.6460177,80.0707965 Z",
    id: "Path-57",
    fill: "url(#linearGradient-48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#292A28",
    points: "55.4336283 80.2831858 62.0176991 80.2831858 61.699115 83.4690265 55.9646018 83.4690265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.950946,80.0410518 C78.1140919,74.0824331 76.9200997,69.8935438 76.3689694,67.4743838 C74.5903974,59.6674281 74.5119028,54.453192 76.1334857,51.8316755 C76.2607344,51.8316755 77.4059725,49.1732003 80.8416867,50.9455171 C84.2774009,52.7178339 85.1681416,58.3301706 85.1681416,79.5979726 L85.1681416,83.3818016 L80.8141593,83.3628319 L79.950946,80.0410518 Z",
    id: "Path-57-Copy",
    fill: "url(#linearGradient-49)",
    transform: "translate(80.070796, 66.859042) scale(-1, 1) translate(-80.070796, -66.859042) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#292A28",
    transform: "translate(77.097345, 81.876106) scale(-1, 1) translate(-77.097345, -81.876106) ",
    points: "73.699115 80.2831858 80.4955752 80.2831858 80.1769912 83.4690265 74.4424779 83.4690265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8318584,84.3185841 C60.8259485,84.3185841 62.4424779,85.9351135 62.4424779,87.9292035 L62.4424779,90.6902655 L62.4424779,90.6902655 L55.2212389,90.6902655 L55.2212389,87.9292035 C55.2212389,85.9351135 56.8377683,84.3185841 58.8318584,84.3185841 Z",
    id: "Rectangle-Copy-13",
    fill: "#343532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0973451,84.3185841 C79.0914352,84.3185841 80.7079646,85.9351135 80.7079646,87.9292035 L80.7079646,90.6902655 L80.7079646,90.6902655 L73.4867257,90.6902655 L73.4867257,87.9292035 C73.4867257,85.9351135 75.1032551,84.3185841 77.0973451,84.3185841 Z",
    id: "Rectangle-Copy-14",
    fill: "#343532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7699115,88.5663717 L59.8938053,88.5663717 C61.4186977,88.5663717 62.6548673,89.8025412 62.6548673,91.3274336 L62.6548673,91.3274336 L62.6548673,91.3274336 L55.0088496,91.3274336 C55.0088496,89.8025412 56.2450191,88.5663717 57.7699115,88.5663717 Z",
    id: "Rectangle",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0353982,88.5663717 L78.159292,88.5663717 C79.6841844,88.5663717 80.920354,89.8025412 80.920354,91.3274336 L80.920354,91.3274336 L80.920354,91.3274336 L73.2743363,91.3274336 C73.2743363,89.8025412 74.5105058,88.5663717 76.0353982,88.5663717 Z",
    id: "Rectangle-Copy-5",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1061947,87.079646 C60.8594719,87.079646 61.4982595,87.569834 61.7209736,88.2486258 C61.3313967,87.7931142 60.7525092,87.5044248 60.1061947,87.5044248 L60.1061947,87.5044248 L57.7699115,87.5044248 C56.9313808,87.5044248 56.206347,87.9903629 55.8610547,88.6959944 L55.8584071,88.7787611 C55.8584071,87.8403657 56.6191268,87.079646 57.5575221,87.079646 L60.1061947,87.079646 Z",
    id: "Combined-Shape",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3716814,87.079646 C79.1249586,87.079646 79.7637463,87.569834 79.9864604,88.2486258 C79.5968835,87.7931142 79.017996,87.5044248 78.3716814,87.5044248 L78.3716814,87.5044248 L76.0353982,87.5044248 C75.1968675,87.5044248 74.4718337,87.9903629 74.1265415,88.6959944 L74.1238938,88.7787611 C74.1238938,87.8403657 74.8846135,87.079646 75.8230088,87.079646 L78.3716814,87.079646 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1061947,86.0176991 C60.8594719,86.0176991 61.4982595,86.5078871 61.7209736,87.1866789 C61.3313967,86.7311673 60.7525092,86.4424779 60.1061947,86.4424779 L60.1061947,86.4424779 L57.7699115,86.4424779 C56.9313808,86.4424779 56.206347,86.928416 55.8610547,87.6340475 L55.8584071,87.7168142 C55.8584071,86.7784188 56.6191268,86.0176991 57.5575221,86.0176991 L60.1061947,86.0176991 Z",
    id: "Combined-Shape-Copy-8",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3716814,86.0176991 C79.1249586,86.0176991 79.7637463,86.5078871 79.9864604,87.1866789 C79.5968835,86.7311673 79.017996,86.4424779 78.3716814,86.4424779 L78.3716814,86.4424779 L76.0353982,86.4424779 C75.1968675,86.4424779 74.4718337,86.928416 74.1265415,87.6340475 L74.1238938,87.7168142 C74.1238938,86.7784188 74.8846135,86.0176991 75.8230088,86.0176991 L78.3716814,86.0176991 Z",
    id: "Combined-Shape-Copy-9",
    fill: "#F8F8F8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "stress",
    transform: "translate(234.323077, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 71.323077)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-50)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 37.4153846,
    cy: 2.33846154,
    rx: 37.4153846,
    ry: 2.33846154
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-51)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 37.4153846,
    cy: 1.75384615,
    rx: 18.7076923,
    ry: 1.75384615
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-52)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 37.025641,
    cy: 73.6615385,
    rx: 7.79487179,
    ry: 1.16923077
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "pressure",
    transform: "translate(4.049944, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-53)",
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    xlinkHref: "#path-56"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-55)",
    xlinkHref: "#path-56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    xlinkHref: "#path-58"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-59)",
    xlinkHref: "#path-58"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#linearGradient-57)",
    strokeWidth: 0.509235578,
    strokeLinejoin: "square",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 30.1114915
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-60"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-61)",
    xlinkHref: "#path-60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-64)",
    xlinkHref: "#path-63"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-62)",
    strokeWidth: 0.507936508,
    xlinkHref: "#path-63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.5,
    transform: "translate(32.535117, 32.535117) rotate(-90.000000) translate(-32.535117, -32.535117) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-66)",
    xlinkHref: "#path-65"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-62)",
    strokeWidth: 0.507936508,
    xlinkHref: "#path-65"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.5351171,55.309699 C45.1131713,55.309699 55.309699,45.1131713 55.309699,32.5351171 C55.309699,19.9570628 45.1131713,9.76053512 32.5351171,9.76053512 C19.9570628,9.76053512 9.76053512,19.9570628 9.76053512,32.5351171",
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 0.507936508,
    strokeLinecap: "round",
    strokeDasharray: "7.126192607576884,9.501590789310516",
    transform: "translate(32.535117, 32.535117) rotate(-45.000000) translate(-32.535117, -32.535117) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5351171,12.4717949 C43.6157839,12.4717949 52.5984392,21.4544502 52.5984392,32.5351171 C52.5984392,38.0754505 50.3527754,43.091281 46.7220282,46.7220282 L32.5351171,32.5351171 L18.3482059,46.7220282 C14.7174587,43.091281 12.4717949,38.0754505 12.4717949,32.5351171 C12.4717949,21.4544502 21.4544502,12.4717949 32.5351171,12.4717949 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7220282,18.3481522 C50.3527754,21.9788994 52.5984392,26.9947299 52.5984392,32.5350633 C52.5984392,38.0753968 50.3527754,43.0912273 46.7220282,46.7219745 L32.5351171,32.5351171 Z",
    id: "Combined-Shape",
    fill: "#FF520B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    x: 25.4858417,
    y: 49.3449275,
    width: 14.0985507,
    height: 1.62675585,
    rx: 0.695652174
  }), /*#__PURE__*/React.createElement("g", {
    id: "needle",
    transform: "translate(33.732188, 28.368644) rotate(43.000000) translate(-33.732188, -28.368644) translate(25.547572, 14.922490)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4",
    transform: "translate(8.055209, 13.211997) rotate(-28.000000) translate(-8.055209, -13.211997) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-69)",
    xlinkHref: "#path-68"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-68"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 3.25351171
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 1.62675585
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 32.5351171,
    cy: 32.5351171,
    r: 1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarMindIcon);
export default __webpack_public_path__ + "static/media/pillar-mind-icon.e004bcf8d0f2981850135830f85fc05d.svg";
export { ForwardRef as ReactComponent };